import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

function RightNav({ open }) {
	return (
		<NavOptions open={open}>
			<NavLink activeStyle={{ color: "rgb(0, 218, 247)" }} exact={true} to="/">
				Home
			</NavLink>
			<NavLink activeStyle={{ color: "rgb(0, 218, 247)" }} to="/about">
				About
			</NavLink>
			<NavLink activeStyle={{ color: "rgb(0, 218, 247)" }} to="/projects">
				Projects
			</NavLink>
			<NavLink activeStyle={{ color: "rgb(0, 218, 247)" }} to="/contact">
				Contact
			</NavLink>
		</NavOptions>
	);
}
const NavOptions = styled.div`
	display: flex;
	justify-content: space-around;
	flex: 0.45;
	padding: 12px;
	align-items: center;
	a {
		text-decoration: none;
		color: #fff;
		font-size: 1.3em;
		transition: 200ms color ease-in;
		&:hover {
			color: rgb(0, 218, 247);
		}
	}
	@media (max-width: 890px) {
		flex-flow: column nowrap;
		min-width: 300px;
		/* margin-left: 10px; */
		justify-content: flex-start;
		padding-top: 3.5rem;

		width: 300px;
		height: 100vh;
		flex-flow: column nowrap;
		top: 0;
		right: 0;
		transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
		transition: transform 0.3s ease-in-out;
		background: rgba(4, 26, 29, 0.8);
		/* background: rgba(61, 58, 59, 0.8); */

		a {
			padding: 12px;
			width: 100%;
			border-bottom: 1px solid whitesmoke;
			margin-left: 10px;
		}
	}
`;
export default RightNav;
